<template>
</template>

<script>
	import * as turf from '@turf/turf';

	export default {
		name: 'FloorLoader',
		data() {
			return {
				defaultRotation: 0
			}
		},
		computed: {
			location() { return this.$store.state.location },
			floor_level() {
				return this.$store.state.floor_level
			},
			map() {
				return this.$store.state.map.map
			},
			drawLayer() {
				return this.$store.state.map.drawLayer
			},
			floors: {
				get() { return this.$store.state.floors },
				set(value) {
					this.$store.commit('setState', ["floors", value]);
				}
			}
		},
		mounted() {
			this.defaultRotation = this.map.getView().getRotation() * -1
			this.init()
		},
		methods: {
			init: function() {
				for (let i in this.floors) {
					this.loadFloor(this.floors[i]);
				}
			},
			loadFloor(rec) {
				let img = require(`assets/img/${rec.img}`);
				var geoimg = new ol.layer.Image({
					name: "floor-"+rec.id,
					id: rec.id,
					type: 'floor',
					floor_level: rec.floor_level,
					opacity: rec.opacity,
					source: new ol.source.GeoImage({
						url: img,
						imageCenter: ol.proj.fromLonLat([rec.long, rec.lat]),
						imageScale: [rec.scale_x, rec.scale_y],
						imageRotate: this.defaultRotation + rec.rotation * (Math.PI/180),
						projection: 'EPSG:3857'
					})
				});
				this.map.addLayer(geoimg);
			}
		}
	}
</script>
